export const API_VERSION = {
  PUBLIC: 'v1',
  PROTECTED: 'v2',
}

export const API_CONSUMER = 'CLIENTES'

export const HTTP_HEADERS = {
  AUTHORIZATION: 'Authorization',
  CONSUMER: 'consumidor',
}

export const AUTH_SCHEME = 'Bearer'

const versionedPath = (version, path) => `/${version}${path}`
const protectedPath = (path) => versionedPath(API_VERSION.PROTECTED, path)
const publicPath = (path) => versionedPath(API_VERSION.PUBLIC, path)

export const AUTH_API_PATHS = {
  SHARE_SESSION: publicPath('/login/share-session'),
  LOGOUT: publicPath('/logout'),
  REFRESH: publicPath('/login/refresh'),
}

export const INFORMES_API_PATHS = {
  TOP_DENUNCIANTES: protectedPath('/top-denunciantes'),
  TOP_JUDICIALES: protectedPath('/top-judiciales'),
  EVOLUCION_SINIESTROS: protectedPath('/evolucion-siniestros'),
  RANKING_DENUNCIAS: protectedPath('/ranking-denuncias'),
  GRAFICOS_TIPO_ACCIDENTE: protectedPath('/graficos/tipo-accidente'),
  GRAFICOS_GRAVEDAD: protectedPath('/graficos/gravedad'),
  GRAFICOS_DENUNCIAS: protectedPath('/graficos/denuncias'),
  INDICADORES_DENUNCIAS: protectedPath('/indicadores/denuncias'),
  INDICADORES_ESTADO: protectedPath('/indicadores/estado'),
  INDICADORES_FRECUENCIA: protectedPath('/indicadores/frecuencia'),
  CHECK_SINIESTRO: protectedPath('/check-siniestro'),
  GENERATE_PDF: protectedPath('/reporte/generate-pdf'),
  INSI_SIN_DATOS: protectedPath('/reporte/insi-sin-datos'),
}

export const COMPANY_API_PATHS = {
  DATOS: (contrato) => protectedPath(`/datos/${contrato}`),
}
